import type { ButtonInputSubmit } from '@cloudsuite/mosaic-elements'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { consume } from '@lit/context'
import { html, LitElement, type CSSResultGroup } from 'lit'
import { customElement } from 'lit/decorators.js'
import { DeliveryMatchActionsContext, DeliveryMatchDeliveryAddressContext, DeliveryMatchSearchedZipcodeContext, type DeliveryMatchActionsContextType, type DeliveryMatchDeliveryAddressContextType } from './provider.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { GEOLOCATION } from '@cloudsuite/mosaic-shared/scripts/geolocation.js'
import { style } from './delivery-match-zip-search.style.js'

@customElement('csc-delivery-match-zip-search')
export class CSCDeliveryMatchZipSearch extends LitElement {

  static override styles?: CSSResultGroup = [style]

  @consume({ context: DeliveryMatchActionsContext })
  private actions!: DeliveryMatchActionsContextType

  @consume({ context: DeliveryMatchSearchedZipcodeContext, subscribe: true })
  private searchedZipcode!: string

  @consume({ context: DeliveryMatchDeliveryAddressContext, subscribe: true })
  private deliveryAddress!: DeliveryMatchDeliveryAddressContextType

  @inject(GEOLOCATION)
  geoLocation!: Geolocation

  private handleLocationClick = () => {
    this.geoLocation.getCurrentPosition((geo: GeolocationPosition) => {
      this.actions.searchForLocationByGeolocation({
        lat: `${geo.coords.latitude}`,
        lon: `${geo.coords.longitude}`,
      })
    }, (e: GeolocationPositionError) => {
      console.error(e.message)
    })
  }

  private handleSubmit = (e: ButtonInputSubmit) => {
    if (e.value.trim()) {
      this.actions.searchForLocation(e.value)
    }
  }

  override render() {
    return html`
    <div class="zip-search">
      <cse-button-input placeholder="${t('zip_search_placeholder', { ns: 'csc-delivery-match', default: 'Search for your postal code' })}" value="${this.searchedZipcode || this.deliveryAddress.zipcode}"
        @cse-button-input-submit=${this.handleSubmit}>
        <cse-icon-button size="small" variant="secondary" @click=${this.handleLocationClick} slot="suffix-icon">
          <cse-icon icon-name="location-crosshairs" icon-style="light"></cse-icon>
        </cse-icon-button>
        <span slot="button-text">${t('search_zip', { ns: 'csc-delivery-match', default: 'Search' })}</span>
      </cse-button-input>
    </div>
      `
  }
}
